import { useState } from 'react';
import type { OrgTabOptionsValue } from 'src/types';
import { Header, Body } from './shared';

export const OrgSettings = () => {
  const [currentTab, setCurrentTab] = useState<OrgTabOptionsValue>('users');

  return (
    <div className='flex w-full flex-col items-center justify-center'>
      <Header currentTab={currentTab} setCurrentTab={setCurrentTab} />
      <Body currentTab={currentTab} />
    </div>
  );
};
